import Multiselect from './MultiSelect'
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export default function SearchBar() {

  const [searchParams, setSearchParams] = useSearchParams()
  const [value, setValue] = useState(searchParams.get('title'));
  const [clearSelectBox, setClearSelectBox] = useState(false);

  const params = useParams()
  const isCategoryRoute =
    params.typeId &&
    params.typeId !== 'all' &&
    params.typeId !== 'games' &&
    params.typeId !== 'videos'

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      setClearSelectBox(!clearSelectBox)
      setSearchParams({ title: value })
    }
  }

  return (
    <>
      {isCategoryRoute ? (
        <div className='row' style={{ margin: '0', position: 'sticky', top: '0', zIndex: 999 }}>
          <div className='col-md-5 searchTypeRow mobOrange'>
            <div className='searchType'>
              <input type='text' placeholder='جستجوی بازی...' defaultValue={value} onKeyUp={handleSearch} onChange={(e) => setValue(e.target.value)} />
            </div>
          </div>
          <div className='col-md-7 border-right searchTypeRow'>
            <Multiselect clear={clearSelectBox} />
          </div>
        </div>

      ) : (
        <div className='row' style={{ margin: '0', position: 'sticky', top: '0', zIndex: 999 }}>
          <div className='col-md-12 searchTypeRow mobOrange'>
            <div className='searchType'>
              <input type='text' placeholder='جستجوی بازی...' defaultValue={value} onKeyUp={handleSearch} onChange={(e) => setValue(e.target.value)} />
            </div>
          </div>
        </div>
      )}

    </>
  )
}
